import { SVGProps, Ref, forwardRef } from 'react';

export const EmptySize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <rect x={-1} y={-1} width={26} height={26} stroke="currentColor" strokeWidth={2} />
            </g>
        </g>
    </svg>
));
EmptySize24Glyph.displayName = 'EmptySize24Glyph';
